import React, { useEffect, useState } from 'react';
import api from '../api';

const Fixtures = () => {
  const [fixtures, setFixtures] = useState([]);
  const [venues, setVenues] = useState([]);
  const [form, setForm] = useState({ type: 'session', label: '', date: '', venue_id: '', notes: '' });
  const [error, setError] = useState('');

  const load = () => Promise.all([api.get('/api/fixtures'), api.get('/api/venues')])
    .then(([f, v]) => { setFixtures(f.data); setVenues(v.data); });
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await api.post('/api/fixtures', { ...form, venue_id: form.venue_id || null });
      setForm({ type: 'session', label: '', date: '', venue_id: '', notes: '' });
      load();
    } catch (err) {
      setError(err.response?.data?.error || 'Could not add fixture');
    }
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this fixture?')) return;
    try {
      await api.delete(`/api/fixtures/${id}`);
      load();
    } catch (err) {
      alert(err.response?.data?.error || 'Could not delete');
    }
  };

  const fmtDate = (d) => new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });

  return (
    <>
      <h1>Fixtures</h1>
      <div className="card">
        <h2>Add a fixture</h2>
        {error && <div className="error-msg">{error}</div>}
        <form onSubmit={submit}>
          <div className="form-grid">
            <div className="form-row">
              <label>Type</label>
              <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}>
                <option value="session">Regular session</option>
                <option value="away_game">Away game</option>
              </select>
            </div>
            <div className="form-row">
              <label>Date</label>
              <input type="date" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} required />
            </div>
            <div className="form-row">
              <label>Label (optional)</label>
              <input value={form.label} onChange={e => setForm({ ...form, label: e.target.value })} placeholder="e.g. U14s training" />
            </div>
            {form.type === 'away_game' && (
              <div className="form-row">
                <label>Venue</label>
                <select value={form.venue_id} onChange={e => setForm({ ...form, venue_id: e.target.value })} required>
                  <option value="">Select…</option>
                  {venues.filter(v => !v.is_home_court).map(v => (
                    <option key={v.id} value={v.id}>{v.name} ({v.round_trip_miles ?? '?'} mi)</option>
                  ))}
                </select>
              </div>
            )}
          </div>
          <button className="btn" type="submit">Add fixture</button>
        </form>
      </div>

      <div className="card">
        <h2>All fixtures</h2>
        <table>
          <thead><tr><th>Date</th><th>Type</th><th>Label / venue</th><th></th></tr></thead>
          <tbody>
            {fixtures.map(f => (
              <tr key={f.id}>
                <td>{fmtDate(f.date)}</td>
                <td>{f.type === 'away_game' ? 'Away game' : 'Session'}</td>
                <td>{f.type === 'away_game' ? f.venue_name : (f.label || '—')}</td>
                <td><button className="btn small secondary" onClick={() => remove(f.id)}>Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Fixtures;
